import { type FC } from "react";

import { Button } from "@mantine/core";
import { clsx } from "clsx";
import { useIntl } from "react-intl";

import snapchatGhostSvg from "@app-assets/svg/snapchat.svg";

import { useAssistantChatOpen } from "../hooks";

import styles from "./AssistantChatFab.module.css";
import { messages } from "./messages.generated";

export const AssistantChatFab: FC = () => {
    const intl = useIntl();
    const { isOpen, toggle } = useAssistantChatOpen();

    return (
        <Button
            unstyled
            className={clsx(styles.fab, isOpen && styles.hidden)}
            onClick={toggle}
            aria-label={intl.formatMessage(messages.fabAriaLabel)}
            aria-expanded={isOpen}
            aria-hidden={isOpen}
            tabIndex={isOpen ? -1 : 0}
        >
            <img className={styles.icon} src={snapchatGhostSvg} alt="" />
        </Button>
    );
};
